import { render } from "./LevelPage.vue?vue&type=template&id=3ae98ef1&scoped=true"
import script from "./LevelPage.vue?vue&type=script&lang=js"
export * from "./LevelPage.vue?vue&type=script&lang=js"

import "./LevelPage.vue?vue&type=style&index=0&id=3ae98ef1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae98ef1"]])

export default __exports__